// extracted by mini-css-extract-plugin
export var carrierIcon = "_w4-0";
export var carrierLogo = "_w4-1";
export var detailsSection = "_w4-2";